import { useVideoApi } from 'hooks/api/backend/useVideoApi';
import React, { ReactElement, useState } from 'react';
import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import { Pagination } from 'components/common/Table/Pagination';
import { VideoCardSkeleton } from 'components/atoms/VideoCardSkeleton';
import { ModalVideoCard } from '../ModalVideoCard';

type Props = {
  onSelect: (data: {
    videoUrl: string;
    title: string;
    description?: string;
    thumbnailUrl?: string;
    qrCodeUrl?: string;
  }) => void;
};

export const VideoLibrary = ({ onSelect }: Props): ReactElement => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { data: videoData, isLoading } = useVideoApi({
    page: currentPage,
  });
  const [skeletonKeys] = useState(() =>
    Array.from({ length: 6 }, (_, i) => `video-skeleton-${i}-${Math.random()}`)
  );

  const handlePageChange = (newPage: number): void => {
    setCurrentPage(newPage);
  };

  return (
    <VStack flex={1} maxHeight="100%" overflow="hidden" gap="0" width="100%">
      <Box flexGrow={1} minWidth="100%" overflow="auto">
        <SimpleGrid
          columns={{ base: 2, lg: 3 }}
          gap="l"
          width="100%"
          maxWidth="100%"
          flexWrap="wrap"
          height="100%"
        >
          {isLoading
            ? skeletonKeys.map((key) => <VideoCardSkeleton key={key} />)
            : videoData?.videos.map((result) => (
                <ModalVideoCard
                  key={result.id}
                  title={result.title}
                  thumbnailUrl={result.thumbnailUrl}
                  description={result.description}
                  videoUrl={result.videoUrl}
                  qrCodeUrl={result.qrCodeUrl}
                  onSelect={onSelect}
                />
              ))}
        </SimpleGrid>
      </Box>
      <Box pt="l">
        <Pagination
          currentPage={currentPage}
          onPageChange={handlePageChange}
          totalPages={videoData?.totalPages || 0}
          noPadding
        />
      </Box>
    </VStack>
  );
};
